import DownloadCLI from "../../../../contents/docs/error-tracking/_snippets/cli/download.mdx";
import AuthenticateCLI from "../../../../contents/docs/error-tracking/_snippets/cli/authenticate.mdx";
import InjectSourceMap from "../../../../contents/docs/error-tracking/upload-source-maps/_snippets/inject-source-map.mdx";
import UploadSourceMap from "../../../../contents/docs/error-tracking/upload-source-maps/_snippets/upload-source-map.mdx";
import UploadSourceMapPlatforms from "../../../../contents/docs/error-tracking/upload-source-maps/_snippets/upload-source-map-platforms.tsx";
import * as React from 'react';
export default {
  DownloadCLI,
  AuthenticateCLI,
  InjectSourceMap,
  UploadSourceMap,
  UploadSourceMapPlatforms,
  React
};